import { initialListPaginationMeta } from "utils/helpers/pagination";

import { ChassisHeightForm, ChassisHeightState } from "../types";

export const initialChassisHeightForm: ChassisHeightForm = {
  manufacturer: "",
  masterModel: "",
  suspensionType: "",
  axleDistance: "",
  tire: "",
  year: "",
  net: "",
  chassisHeightIncludingBody: "",
};

export const initialChassisHeightMeta = initialListPaginationMeta;

export const initialState: ChassisHeightState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialChassisHeightMeta,
  error: null,
  manufacturerFilter: "ALL",
  suspensionTypeFilter: "ALL",
  masterModelFilter: "ALL",
  yearFilter: "2016",
  isAddModalOpen: false,
  form: initialChassisHeightForm,
};
